<template>
  <g>
    <g transform="rotate(-90)">
      <g :transform="`scale(${scale} ${scale})`">
        <rect x="0" y="0" width="84" height="150" fill="white" />
        <g id="g875"
          fill="#d2d2d2">
          <path
            id="path54"
            transform="translate(-983.264,-315.179)"
            d="m 1059.042,322.521 c 0,1.675 -0.04,3.352 0.016,5.025 0.039,1.175 -0.506,1.533 -1.591,1.512 -0.975,-0.019 -1.731,-0.11 -1.72,-1.377 0.032,-3.51 -0.023,-7.021 0.033,-10.53 0.019,-1.184 0.843,-2.081 1.67,-1.954 a 1.843,1.843 0 0 1 1.587,2.059 c 0.017,1.755 0,3.51 0,5.265 z"
          />
          <path
            id="path62"
            transform="translate(-983.264,-315.179)"
            d="m 1016.845,322.419 c 0,1.747 -0.023,3.494 0.01,5.24 0.019,1.03 -0.459,1.39 -1.446,1.39 -0.987,0 -1.469,-0.331 -1.462,-1.372 0.022,-3.573 0.01,-7.146 0.01,-10.719 0,-0.976 0.291,-1.773 1.436,-1.779 1.145,-0.006 1.452,0.779 1.454,1.761 0,1.826 10e-4,3.653 10e-4,5.479 z"
          />
          <path
            id="path64"
            transform="translate(-983.264,-315.179)"
            d="m 992.853,322.33 c 0,-1.59 0,-3.181 0,-4.771 a 2.351,2.351 0 0 1 0.518,-1.777 1.353,1.353 0 0 1 1.47,-0.529 1.254,1.254 0 0 1 0.856,1.046 4.144,4.144 0 0 1 0.056,0.712 c 0,3.5 0.028,7 -0.011,10.5 -0.015,1.339 -0.462,1.634 -1.761,1.53 a 1.056,1.056 0 0 1 -1.116,-1.22 c 0.007,-1.829 0,-3.658 0,-5.487 z"
          />
          <path
            id="path66"
            transform="translate(-983.264,-315.179)"
            d="m 1035.045,322.246 q 0,-2.5 0,-5.01 c 0,-0.9 0,-1.837 1.161,-2.033 0.889,-0.149 1.681,0.8 1.723,2.131 0.055,1.748 0.016,3.5 0.016,5.248 0,1.59 -0.022,3.181 0.01,4.771 0.017,0.984 -0.122,1.728 -1.384,1.693 -1.262,-0.035 -1.484,-0.21 -1.516,-1.791 -0.033,-1.669 -0.01,-3.339 -0.01,-5.009 z"
          />
          <path
            id="path90"
            transform="translate(-983.264,-315.179)"
            d="m 1057.409,331.943 c -0.791,0 -1.582,0 -2.373,0 -0.605,0 -1.105,-0.155 -1.148,-0.888 -0.042,-0.716 0.366,-1 1.013,-1.008 q 2.491,-0.018 4.983,0 c 0.64,0 1.063,0.27 1.029,0.991 -0.034,0.721 -0.519,0.9 -1.131,0.9 -0.791,0.008 -1.582,0.005 -2.373,0.005 z"
          />
          <path
            id="path92"
            transform="translate(-983.264,-315.179)"
            d="m 994.4,331.941 c -0.8,0 -1.594,0.013 -2.391,0 -0.647,-0.013 -1.063,-0.3 -1.026,-1.015 a 0.839,0.839 0 0 1 0.915,-0.877 c 1.674,-0.012 3.348,-0.02 5.02,0.021 a 1,1 0 0 1 1.059,1.058 c 0,0.786 -0.614,0.816 -1.185,0.826 -0.8,0.014 -1.6,0 -2.392,0 z"
          />
          <path
            id="path94"
            transform="translate(-983.264,-315.179)"
            d="m 1036.2,331.946 c -0.8,0 -1.594,0.014 -2.391,-0.006 -0.507,-0.012 -0.973,-0.158 -0.987,-0.782 a 0.935,0.935 0 0 1 0.8,-1.032 20.736,20.736 0 0 1 2.38,-0.1 c 0.956,-0.011 1.913,0 2.869,0.021 a 0.852,0.852 0 0 1 0.949,0.845 c 0.05,0.7 -0.327,1.034 -0.991,1.048 -0.876,0.019 -1.753,0 -2.63,0 z"
          />
          <path
            id="path102"
            transform="translate(-983.264,-315.179)"
            d="m 1015.463,331.939 c -0.789,0 -1.578,0.014 -2.366,0 -0.638,-0.014 -1.053,-0.29 -1.017,-1 a 0.831,0.831 0 0 1 0.895,-0.878 c 1.655,-0.013 3.311,-0.013 4.965,0.026 0.568,0.013 0.8,0.419 0.781,0.968 a 0.837,0.837 0 0 1 -0.893,0.881 c -0.788,0.027 -1.577,0.007 -2.365,0.007 z"
          />
        </g>
        <g id="g881"
          :fill="getCssColor('schwarz')">
          <path
            id="path8"
            transform="translate(-983.264,-315.179)"
            d="m 995.437,441.2 h 61.472 c 0.481,0.63 0.089,1.11 -0.088,1.6 a 121.764,121.764 0 0 0 -5.094,16.94 58.6,58.6 0 0 0 -0.959,11.914 q 0.042,8.511 0,17.02 c -0.021,3.225 -1.286,4.431 -4.588,4.434 -13.187,0.011 -26.375,-0.054 -39.561,0.05 -2.944,0.023 -4.687,-1.852 -4.618,-4.5 0.137,-5.271 -0.18,-10.557 0.05,-15.821 0.373,-8.538 -1.4,-16.658 -4.158,-24.638 -0.781,-2.238 -1.575,-4.48 -2.456,-6.999 z"
          />
          <path
            id="path10"
            transform="translate(-983.264,-315.179)"
            d="m 1026.574,385.161 h 38.4 c 0.56,0 1.122,0.033 1.679,-0.006 0.785,-0.055 1.163,0.191 1.158,1.061 q -0.039,7.437 0,14.875 c 0,0.7 -0.254,1 -0.972,0.993 q -6.24,-0.026 -12.479,-0.008 c -0.716,0 -1,-0.349 -0.952,-1.037 0.017,-0.238 0,-0.479 0,-0.719 -0.065,-3.2 -0.065,-3.2 -3.156,-3.2 h -47.517 c -0.4,0 -0.8,0 -1.2,0 -2.088,0.021 -2.088,0.021 -2.114,2.077 -0.038,2.881 -0.038,2.882 -2.964,2.882 -3.36,0 -6.72,-0.035 -10.079,0.021 -1.03,0.017 -1.4,-0.3 -1.395,-1.342 0.02,-4.8 -0.016,-9.6 -0.037,-14.4 0,-0.9 0.393,-1.307 1.318,-1.209 a 13.535,13.535 0 0 0 1.439,0.008 z"
          />
          <path
            id="path14"
            d="m 42.913,98.711454 q -11.745,0 -23.489,0 c -2.563,0 -2.232,0.311 -2.243,-2.331 q -0.024,-5.873 0,-11.745 c 0.006,-1.845 0.023,-1.872 1.757,-1.872 q 24.208,-0.012 48.417,0 c 1.752,0 1.77,0.029 1.776,1.865 q 0.018,5.993 0,11.984 c 0,2.33 0.266,2.1 -2.25,2.1 q -11.984,0.006 -23.968,-10e-4 z"
          />
          <path
            id="path4663"
            d="M 11.199034,124.25848 2.1331494,96.927322 1.8665057,88.128081 H 15.731977 V 99.593759 H 70.127286 V 87.861437 h 14.132115 v 10.13246 l -9.599172,26.797863 z"
          />
        </g>
        <g id="g865"
          :fill="getCssColor(plugColor)">
          <path
            id="path12"
            d="m 35.958,59.515906 c 0.05,1.953201 0.059,3.914592 0.169,5.851413 0.03692,1.031141 0.450153,1.836434 0.955,1.861069 0.589,0.0778 0.816,-0.782099 1,-1.734131 0.199968,-1.413574 0.267822,-2.891723 0.2,-4.356826 0.006,-6.199468 -0.021,-12.398936 0.013,-18.598404 0.019,-3.46212 0.082,-3.570631 1.761,-3.640242 1.832,-0.07575 3.667,0.06961 5.5,-0.04504 1.164,-0.07166 1.524,0.986838 1.512,3.224625 -0.037,6.688792 -0.021,13.379631 0,20.064328 -0.0069,1.296637 0.0602,2.590488 0.2,3.855218 0.128254,0.816194 0.521257,1.33143 0.937,1.228428 0.416688,-0.04011 0.748382,-0.729019 0.762,-1.582625 0.14,-2.069902 0.461,-6.201516 0.461,-6.201516 l 7.642,0.143317 c 0,0 0.036,3.933018 0.145,5.878029 0.03969,1.046109 0.489644,1.823622 1,1.727989 0.607,-0.03276 0.8,-0.904942 0.833,-1.96139 0.031,-0.978648 0.024,-1.963438 0.024,-2.946181 0,-5.732665 -0.006,-11.46533 0,-17.197995 0.01,-6.613039 -0.33,-6.207658 2.909,-6.209705 h 20.155 c 0.56,0 1.12,0.0389 1.679,0.02457 0.684344,-0.236763 1.659242,0.963319 1.557091,2.368819 0,8.514373 0.0017,17.028746 0.005,25.543119 0,1.869258 -0.822091,2.661595 -1.702091,2.6186 -0.56,-0.02662 -1.12,0 -1.68,0 H 3.055 c -3.164,0 -3,0.520034 -3,-6.095052 0,-6.71336 -0.021,-13.426721 0.009,-20.140082 0.017,-3.982155 0.148,-4.299499 2.015,-4.299499 7.358,-0.04777 14.716333,-0.04777 22.075,0 1.768,0.01228 1.818,0.165838 1.835,4.010819 0.027,6.058199 0,12.116397 0.01,18.176644 -0.06629,1.470514 0.0015,2.953446 0.2,4.373204 0.178,0.952032 0.4,1.842643 0.991,1.773032 0.506077,-0.0096 0.924613,-0.80961 0.964,-1.842643 0.112,-1.945011 0.179,-5.871887 0.179,-5.871887 h 7.625 z"
          />
          <path
            id="path18"
            transform="translate(-983.264,-315.179)"
            d="m 1050.447,341.513 c 0,-3.356 -0.024,-6.713 0.012,-10.068 0.014,-1.187 0.614,-1.606 1.636,-1.357 0.9,0.219 0.747,0.937 0.738,1.538 -0.019,1.254 0.627,1.691 1.792,1.673 1.758,-0.026 3.517,0.024 5.274,-0.013 1.757,-0.037 1.827,-0.077 2.038,-1.865 0.1,-0.815 0.219,-1.368 1.209,-1.378 1.171,-0.011 1.236,0.713 1.235,1.582 -0.01,6.633 -0.02,13.266 0.01,19.9 0,1.127 -0.417,1.559 -1.545,1.546 -3.6,-0.039 -7.193,-0.051 -10.788,0.007 -1.305,0.021 -1.624,-0.564 -1.608,-1.735 0.045,-3.275 0.016,-6.552 0.016,-9.829 z"
          />
          <path
            id="path20"
            transform="translate(-983.264,-315.179)"
            d="m 1001.456,341.761 c 0,3.2 -0.031,6.4 0.016,9.592 0.017,1.183 -0.327,1.744 -1.62,1.724 -3.6,-0.058 -7.195,-0.045 -10.791,-0.007 -1.124,0.013 -1.557,-0.407 -1.552,-1.54 0.029,-6.715 0,-13.43 0.029,-20.145 0,-1.132 0.7,-1.573 1.694,-1.286 0.745,0.215 0.613,0.81 0.692,1.346 0.258,1.749 0.3,1.8 2.075,1.842 1.519,0.036 3.038,0.02 4.557,0.006 2.068,-0.02 2.068,-0.029 2.493,-2.171 a 1.313,1.313 0 0 1 1.942,-0.938 c 0.6,0.36 0.456,0.97 0.458,1.5 0.013,3.362 0.01,6.716 0.01,10.077 z"
          />
          <path
            id="path28"
            transform="translate(-983.264,-315.179)"
            d="m 1021.978,353 c -0.7,-1.122 -0.362,-2.163 -0.417,-3.136 -0.054,-0.956 0.027,-1.92 -0.026,-2.877 -0.106,-1.938 -0.651,-2.553 -2.5,-2.356 -2.4,0.255 -4.789,0.086 -7.182,0.149 -2.356,0.063 -2.538,0.211 -2.594,2.655 -0.03,1.358 0,2.718 -0.01,4.077 0,0.388 0.067,0.805 -0.295,1.126 -0.592,-0.486 -0.319,-1.156 -0.322,-1.73 -0.032,-6.156 -0.033,-12.311 -0.041,-18.467 0,-0.4 0.01,-0.8 0.011,-1.2 0,-0.617 0.17,-1.1 0.9,-1.161 a 1.2,1.2 0 0 1 1.444,0.92 c 0.7,2.292 0.718,2.287 3.127,2.292 1.2,0 2.4,0.024 3.6,-0.006 1.782,-0.045 1.8,-0.058 2.13,-1.794 0.106,-0.563 0.129,-1.115 0.766,-1.362 a 1.36,1.36 0 0 1 1.933,1.107 5.876,5.876 0 0 1 0.031,0.958 q 0,9.592 0,19.186 a 1.861,1.861 0 0 1 -0.555,1.619 z"
          />
          <path
            id="path32"
            transform="translate(-983.264,-315.179)"
            d="m 1043.005,352.789 c -0.935,-1.6 -0.643,-3.26 -0.667,-4.88 -0.052,-3.406 -0.018,-3.409 -3.506,-3.416 -2.075,0 -4.152,-0.04 -6.226,0.014 -1.812,0.046 -2.225,0.483 -2.276,2.3 -0.043,1.515 0.01,3.033 -0.022,4.549 -0.01,0.5 0.195,1.105 -0.412,1.436 -0.653,-0.242 -0.522,-0.774 -0.523,-1.207 q -0.016,-9.937 0,-19.875 c 0,-0.535 -0.146,-1.144 0.437,-1.516 a 1.308,1.308 0 0 1 1.943,0.922 c 0.431,2.149 0.431,2.157 2.481,2.178 1.437,0.015 2.874,0.02 4.31,0 1.988,-0.03 2.028,-0.036 2.324,-2.065 0.11,-0.753 0.328,-1.165 1.152,-1.179 0.922,-0.016 1.287,0.4 1.285,1.293 -0.019,6.944 -0.023,13.887 -0.047,20.831 a 1.832,1.832 0 0 1 -0.253,0.615 z"
          />
          <rect
            y="31.958473"
            x="28.187559"
            height="4.7136388"
            width="8.0131855"
            id="rect848"
          />
          <rect
            y="31.958473"
            x="48.92757"
            height="4.9021845"
            width="8.2960043"
            id="rect850"
          />
          <rect
            y="39.028931"
            x="28.093287"
            height="17.911827"
            width="8.5788221"
            id="rect852"
          />
          <rect
            y="38.65184"
            x="48.833298"
            height="18.571737"
            width="8.6730947"
            id="rect854"
          />
        </g>
      </g>
    </g>
  </g>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getCssColor"])
  },
  props: {
    scale: {
      type: Number,
      default: .45
    },
    plugColor: {
      type: String,
      default: 'default'
    },
    flip: {
      type: Boolean,
      default: false
    },
    width:{
      type: Number,
      default: 80
    },
    horizontalPadding: {
      type: Number,
      default: 20
    }
  }
};
</script>

<style>
</style>